import { ClonableItem } from 'src/app/shared/models/clonable-item';
import ICalculationResult = ZoningAPI.ICalculationResult;
import ICalculationStatistic = ZoningAPI.ICalculationStatistic;
import IZoningCodeSetting = ZoningAPI.IZoningCodeSetting;
import ICalculationResultMetaData = ZoningAPI.ICalculationResultMetaData;

export class CalculationResult extends ClonableItem<ICalculationResult> implements ICalculationResult {
    Id: number;
    PropertyRecordId: number;
    GroupId: string;
    ZoningCodeVersionId: number;
    ZoningAllowanceId?: number;
    ZoningCodeSettingsId?: number;
    Status: number;
    Actuality?: number;
    CalculationTimeMs?: number;
    SaveToDBTimeMs?: number;

    CalculationStatistic?: ICalculationStatistic;
    ZoningCodeSettings?: IZoningCodeSetting;
    ZoningCodeStatus: number;

    MetaData: ICalculationResultMetaData;

    createdAt?: string;
    updatedAt?: string;
}

export function calculationResultFactory(data: ICalculationResult) {
    return new CalculationResult(data);
}
